import {
  MerchantReturnPolicySettings,
  merchantReturnPolicySettingsSchema,
} from "@made-people/grease-structured-data";
import { useStructuredDataSettings } from "./use-structured-data-settings";

export const useGetMerchantReturnPolicySettings = ():
  | MerchantReturnPolicySettings
  | undefined => {
  const structuredDataSettings = useStructuredDataSettings();

  if (!structuredDataSettings) {
    return undefined;
  }

  const merchantReturnPolicyData =
    structuredDataSettings[0]?.merchantReturnPolicy;

  if (!merchantReturnPolicyData) {
    return undefined;
  }

  const transformedData = Array.isArray(merchantReturnPolicyData)
    ? merchantReturnPolicyData.map((entry) => ({
        ...entry,
        merchantReturnDays: entry.merchantReturnDays
          ? parseInt(String(entry.merchantReturnDays))
          : undefined,
      }))
    : [
        {
          ...merchantReturnPolicyData,
          merchantReturnDays: merchantReturnPolicyData.merchantReturnDays
            ? parseInt(String(merchantReturnPolicyData.merchantReturnDays))
            : undefined,
        },
      ];

  const parsedMerchantReturnPolicySettings =
    merchantReturnPolicySettingsSchema.safeParse(transformedData);

  if (!parsedMerchantReturnPolicySettings.success) {
    return undefined;
  }

  return parsedMerchantReturnPolicySettings.data;
};
